import { Component, OnInit } from '@angular/core';
import { CstemapiService } from '../cstemapi.service';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
declare var Highcharts: any;

@Component({
  selector: 'app-stats',
  templateUrl: './stats.component.html',
  styleUrls: ['./stats.component.scss']
})
export class StatsComponent implements OnInit {

  totalVisit;
  totalRegistered;
  totalSimulated;
  sCase: any = '1';
  uRole;
  finDataArr = [];

  constructor(private cstemapi: CstemapiService, private myRoute: Router, private auth: AuthService) {
    this.totolVisitCount();
    this.totolRegisteredUserCount();
    this.totolSimulatedCount();
    this.getRoleBasedLogin();
    this.uRole = this.auth.getUserInfo().roleCode;
    this.getSimulatedCases(this.sCase);
    this.getFinancialCaseSimulated("0");
    this.getFinancialCaseSimulated("1");
    // console.log(this.finDataArr);
    // for (var i = 1; i < this.finDataArr.length; i++) {
    //   for (var j = 0; j < this.finDataArr[i].length; j++) {
    //     this.finDataArr[0][i].data.push(this.finDataArr[i][j].data[0]);
    //   }
    // }
    // console.log(this.finDataArr[0])
    this.registeredUserCount();
  }

  ngOnInit() {
    this.loadScript('./assets/public/javascript/test.js');
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }

  ngAfterViewInit() {
  }

  totolVisitCount() {
    var dObj = {}
    var api = 'statistics/getUserVisitCount'
    this.cstemapi.cstemAPI(dObj).GetUserVisitCount.subscribe(data => {
      // console.log("data", data)
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        // this.totalVisit = resData.userVisitCount[0].count + resData.userVisitCount[1].count;
        this.totalVisit = resData.userVisitCount[1].count + resData.userVisitCount[2].count;
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  totolRegisteredUserCount() {
    var dObj = {}
    var api = 'statistics/getRegisteredUserCount'
    this.cstemapi.cstemAPI(dObj).GetRegisterdUserCount.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.totalRegistered = resData.registeredUserCount;
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  totolSimulatedCount() {
    var dObj = {}
    var api = 'statistics/getSimulatedCaseCount'

    this.cstemapi.cstemAPI(dObj).GetSimulatedCaseCount.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        this.totalSimulated = resData.simulatedCaseCountList[1].count + resData.simulatedCaseCountList[2].count;
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  getRoleBasedLogin() {
    var dObj = {}
    var api = 'statistics/getRoleBasedLogin'
    this.cstemapi.cstemAPI(dObj).GetRoleBasedLogin.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        var rolebasedLogin = resData.roleBasedLoginCountList;
        const options = rolebasedLogin.map(function (row) {
          return { name: row.roleName, y: row.count }
        })
        this.roleChart(options)
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  roleChart(data) {
    Highcharts.chart('rolechart', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: ''
      },
      tooltip: {
        headerFormat: '<span style:"font-size: 14px">{point.key}: </span>',
        pointFormat: '<b>{point.y}</b>',
        style: this.cstemapi.h_x_y_tooltip_format
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
              fontSize: '14px'
            }
          }
        }
      },
      series: [{
        name: 'Brands',
        colorByPoint: true,
        data: data
      }]
    });
  }

  sCaseChange() {
    this.getSimulatedCases(this.sCase)
  }

  getSimulatedCases(demo) {
    var dObj = {
      roleCode: this.uRole,
      isDemoCase: demo
    }
    var api = 'statistics/getApplicationCaseCount'
    this.cstemapi.cstemAPI(dObj).GetApplicationCaseCount.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        var scase = resData.applicationCaseCount;
        var sarr = [], xdata = ['Demo'];
        for (var i = 0; i < scase.length; i++) {
          if (scase[i].code == 'gcmg') {
            sarr.push({
              type: 'column',
              name: 'Grid Connected Mini Grid',
              data: [scase[i].count]
            })
          }
          if (scase[i].code == 'ogmg') {
            sarr.push({
              type: 'column',
              name: 'Off Grid Mini Grid',
              data: [scase[i].count]
            })
          }
          if (scase[i].code == 'util') {
            sarr.push({
              type: 'column',
              name: 'Utility',
              data: [scase[i].count]
            })
          }
        }

        var dObj1 = {
          roleCode: this.uRole,
          isDemoCase: '0'
        }
        var api = 'statistics/getApplicationCaseCount'

        this.cstemapi.cstemAPI(dObj1).GetApplicationCaseCount.subscribe(data => {
          this.cstemapi.printReqRes(dObj, data, api);
          let resData: any = data;
          if (resData.statusCode == 'S001') {
            var scase1 = resData.applicationCaseCount;
            xdata.push('User Defined')
            // console.log(xdata)

            for (var i = 0; i < scase1.length; i++) {
              if (scase1[i].code == 'gcmg') {
                for (var j = 0; j < sarr.length; j++) {
                  if (sarr[j].name == 'Grid Connected Mini Grid') {
                    sarr[j].data.push(scase1[i].count)
                  }
                }
              }
              if (scase1[i].code == 'ogmg') {
                for (var j = 0; j < sarr.length; j++) {
                  if (sarr[j].name == 'Off Grid Mini Grid') {
                    sarr[j].data.push(scase1[i].count)
                  }
                }
              }
              if (scase1[i].code == 'util') {
                for (var j = 0; j < sarr.length; j++) {
                  if (sarr[j].name == 'Utility') {
                    sarr[j].data.push(scase1[i].count)
                  }
                }
              }
            }

            if (sarr.length == 3) {
              this.simulatedcaseChart(xdata, sarr)
              // console.log(sarr)
            }
          }

          if (resData.statusCode == 'E001') {
            this.cstemapi.Swal.fire('Error!', '', 'error');
          }

        }, (error) => {
          this.cstemapi.Swal.fire('Oops...', error, 'error');
        });
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  simulatedcaseChart(xdata, ydata) {
    Highcharts.chart('casechart', {
      title: {
        text: ''
      },
      xAxis: {
        categories: xdata,
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        title: {
          text: '',
          style: this.cstemapi.h_x_y_title_format
        }
      },
      tooltip: {
        style: this.cstemapi.h_x_y_tooltip_format
      },
      series: ydata
    });
  }

  getFinancialCaseSimulated(dobj1) {
    var dObj = {
      roleCode: this.uRole,
      isDemoCase: dobj1
    }
    var api = 'statistics/getFinancialCaseCount'
    this.cstemapi.cstemAPI(dObj).GetFinancialCaseCount.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        var fin = resData.financialCaseCount;
        var findata = [];
        // var findata1 = [];
        for (var i = 0; i < fin.length; i++) {
          if (fin[i].code == 'bid') {
            findata.push({
              name: 'Bid Analysis',
              data: [fin[i].count]
            })
          }
          if (fin[i].code == 'fit') {
            findata.push({
              name: 'Fit Analysis',
              data: [fin[i].count]
            })
          }
          if (fin[i].code == 'lcoe') {
            findata.push({
              name: 'Basic Viability',
              data: [fin[i].count]
            })
          }
          // if (findata.length == 3) {
          //   // this.financialChart(findata.reverse());
          //   this.financialChart(this.finDataArr[0]);
          // }
        }
      }
      this.finDataArr.push(findata)
      if (dobj1 == "1") {
        for (var i = 0; i < this.finDataArr.length; i++) {
          if (i != 0) {
            for (var j = 0; j < this.finDataArr[i].length; j++) {
              this.finDataArr[0][j].data.push(this.finDataArr[i][j].data[0]);
            }
          }
        }
      }

      if (dobj1 == "1") {
        this.financialChart(this.finDataArr[0]);
      }

      // console.log(this.finDataArr[0])

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  financialChart(data) {
    // console.log(data);
    Highcharts.chart('financialChart', {
      chart: {
        type: 'bar'
      },
      title: {
        text: ''
      },
      xAxis: {
        categories: ['userDefined', 'demoCases'],
        labels: {
          style: this.cstemapi.h_x_y_format
        }
      },
      yAxis: {
        min: 0,
        title: {
          text: '',
          style: this.cstemapi.h_x_y_title_format
        }
      },
      tooltip: {
        headerFormat: '',
        pointFormat: '<span>{series.name}</span>: <b>{point.y} ({point.percentage:.0f}%)</b><br/>',
        style: this.cstemapi.h_x_y_tooltip_format
      },
      legend: {
        reversed: true
      },
      plotOptions: {
        series: {
          stacking: 'normal'
        }
      },
      series: data
    });
  }





  registeredUserCount() {
    var dObj = {}
    var api = 'statistics/getRegisteredUserCount'
    this.cstemapi.cstemAPI(dObj).GetRegisterUserCount.subscribe(data => {
      this.cstemapi.printReqRes(dObj, data, api);
      let resData: any = data;
      if (resData.statusCode == 'S001') {
        var rolebasedLogin = resData.registeredUserList;
        const options = rolebasedLogin.map(function (row) {
          return { name: row.roleName, y: row.count }
        })
        this.registeredChart(options)
      }

      if (resData.statusCode == 'E001') {
        this.cstemapi.Swal.fire('Error!', '', 'error');
      }

    }, (error) => {
      this.cstemapi.Swal.fire('Oops...', error, 'error');
    });
  }

  registeredChart(data) {
    Highcharts.chart('registeredchart', {
      chart: {
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'pie'
      },
      title: {
        text: ''
      },
      tooltip: {
        headerFormat: '<span style:"font-size: 14px">{point.key}: </span>',
        pointFormat: '<b>{point.y}</b>',
        style: this.cstemapi.h_x_y_tooltip_format
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
            enabled: true,
            format: '<b>{point.name}</b>: {point.percentage:.1f} %',
            style: {
              color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black',
              fontSize: '14px'
            }
          }
        }
      },
      series: [{
        name: 'Brands',
        colorByPoint: true,
        data: data
      }]
    });
  }
}

